import { useEffect, useState } from 'react';

/** Debounce a value: only settle on the latest one once it's held steady for
 *  `ms`. Each change resets the timer, unlike `useThrottled`'s rate cap. */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [out, setOut] = useState(value);

  useEffect(() => {
    const t = window.setTimeout(() => setOut(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);

  return out;
}
